import { GlobalFooter } from '@old/features/global-footer';
import { GlobalNav } from '@old/features/global-nav';
import { Box, Container, Stack } from '@mui/material';
import { Outlet } from 'react-router';

type Props = {
  withHeader?: boolean;
  withFooter?: boolean;
  withSideSpaces?: boolean;
  backgroundWhite?: boolean;
  fillAvailableSpace?: boolean;
  footerConfig?: { withMarginTop: boolean };
};

export function PrivatePagesLayout({
  withHeader,
  withFooter,
  withSideSpaces,
  backgroundWhite,
  fillAvailableSpace = false,
  footerConfig,
}: Props) {
  const footerHasMarginTop = footerConfig?.withMarginTop ?? true;

  return (
    <Stack
      sx={{
        width: '100%',
        height: fillAvailableSpace ? '100%' : 'auto',
        minHeight: '100%',
        backgroundColor: backgroundWhite ? 'white' : undefined,
      }}
    >
      {withHeader ? (
        <Box sx={{ flex: '0 0 auto' }}>
          <GlobalNav />
        </Box>
      ) : null}

      <Container
        disableGutters
        fixed={withSideSpaces}
        maxWidth={withSideSpaces ? 'xl' : false}
        sx={{
          flex: fillAvailableSpace ? '1 1 0' : '1 0 auto',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: backgroundWhite ? 'white' : undefined,
        }}
      >
        <Outlet />
      </Container>

      {withFooter ? (
        <Box
          sx={{
            flex: '0 0 auto',
            pt: footerHasMarginTop ? '45px' : 0,
            backgroundColor: backgroundWhite ? 'white' : undefined,
          }}
        >
          <GlobalFooter hasMarginTop={false} backgroundColor={backgroundWhite} />
        </Box>
      ) : null}
    </Stack>
  );
}
